<template>
  <el-dialog
    v-if="visibles"
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    :show-close="false"
    center
    top="5vh"
    :width="'60%'"
    class="electricDialog"
  >
    <dialog-header
      slot="title"
      :title="$t('carMonitor.electric.electricNotes.alarmDetail')"
      @close="closeDialog"
    />
    <vue-linetitle
      :title="$t('carMonitor.electric.electricNotes.alarmCar')"
      :icon-config="{icon: 'approve-car-info'}"
    >
      <p class="wl-flex-p" style="margin:3px 0;">
        <span style="line-height:50px;">{{ $t('public.mobile') }}: {{ ruleList.mobile }}</span>
        <span>
          {{ $t('carMonitor.electric.electricManage.carTitle') }}: 
          <vue-licenseplate
            :licensepalte="ruleList.licensePlate"
            :area="ruleList.areaName"
          />
        </span>
      </p>
      <p>
        <!-- <span>{{ $t('carMonitor.electric.electricNotes.alarmTime') }}: {{ ruleList.beginTime }}</span> -->
        <span>{{ $t('carMonitor.electric.electricNotes.alarmMessage') }}: {{ data.message }}</span>
      </p>
    </vue-linetitle>
    <vue-linetitle
      :title="$t('carMonitor.electric.electricNotes.fenceMessage')"
      :icon-config="{icon: 'approve-mileage-info'}"
    >
      <div v-loading="listLoading">
        <div style="margin-bottom:10px;">
          <p class="wl-flex-p">
            <span>{{ $t('carMonitor.electric.electricNotes.ruleName') }}: {{ ruleList.ruleName }}</span>
            <span>{{ $t('carMonitor.electric.electricNotes.alarmType') }}: <i :class="[ruleList.alarmType === 0?'red':ruleList.alarmType === 1?'blue':'']">{{ ruleList.alarmType | switchText('alarmType') }}</i></span>
          </p>
          <p class="wl-flex-p">
            <span>{{ $t('carMonitor.electric.electricNotes.ruleType') }}: {{ ruleList.ruleType | switchText('ruleType') }}</span>
            <span v-show="circle.visible">{{ $t('carMonitor.electric.electricManage.radius') }}：{{ circle.radius }} m</span>
          </p>
          
        </div>
        <div class="amap">
          <vue-map
            :map-type-control="true"
            class="loading-map"
            :language="language"
            :zoom="zoom"
            :zooms="zooms"
            :disable-default-ui="false"
            :center="center"
            :bounds="bounds"
            :fullscreen-control="true"
          >
            <vue-map-marker 
              :position="position" 
              :animation="google.maps.Animation.BOUNCE"
            />
            <vue-map-polygon
              ref="polygonMap"
              :visible="polygon.visible"
              :path="polygon.path"
              :draggable="polygon.draggable"
              :editable="polygon.editable"
              :stroke-color="polygon.strokeColor"
              :stroke-weight="polygon.strokeWeight"
              :stroke-opacity="polygon.strokeOpacity"
              :fill-color="polygon.fillColor"
              :fill-opacity="polygon.fillOpacity"
            />
            <vue-map-circle
              ref="circleMap"
              :visible="circle.visible"
              :center="circle.center"
              :radius="circle.radius"
              :draggable="circle.draggable"
              :editable="circle.editable"
              :stroke-color="circle.strokeColor"
              :stroke-weight="circle.strokeWeight"
              :stroke-opacity="circle.strokeOpacity"
              :fill-color="circle.fillColor"
              :fill-opacity="circle.fillOpacity"
            />
          </vue-map>
        </div>
      </div>
    </vue-linetitle>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import { getUserLanguage } from '@/utils/auth'

export default {
  name: 'AddUpdateDialog',
  filters: {
    switchText(val, type) {
      if (type === 'alarmType') {
        const strs = vm.$t('geofence.out')+"&"+vm.$t('geofence.in')
        return val == 0 ? vm.$t('geofence.out') : val == 1 ? vm.$t('geofence.in') : val == '0,1' ? strs : ''
      } else if (type === 'ruleType') {
        return val === 1 ? vm.$t('geofence.shape.rectangle') : vm.$t('geofence.shape.circle')
      }
    }
  },
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      cars: require("@/assets/carrunning.png"),
      position: [121.5273285, 31.21515044],
      carList: [],
      ruleList: {},
      language: getUserLanguage(),
      listLoading: false,
      // 谷歌地图
      bounds:null, //自适应
      zoom: 12,
      zooms:[0,16],
      center: [121.5273285, 31.21515044],
      polygon: {
        visible: true,
        editable: false,
        draggable: false,
        strokeColor: '#0091ea',
        strokeWeight: 5,
        strokeOpacity: 1,
        fillColor: '#ffff00',
        fillOpacity: 0.5,
        path: []
      },
      circle: {
        visible: false,
        center: [],
        radius: 0,
        editable: false,
        draggable: false,
        strokeColor: '#0091ea',
        strokeWeight: 5,
        strokeOpacity: 1,
        fillColor: '#ffff00',
        fillOpacity: 0.5
      },
      google: window.google
    }
  },
  computed: {
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.ruleList = this.data
        this.rulesTypeUpdate()
      }
    }
  },
  created() {

  },
  methods: {
    // 关闭
    closeDialog() {
      this.restData()
      this.$emit('update:visibles', false)
    },
    restData() {
      this.polygon.path = []
      this.circle.radius = 0
      this.circle.center = []
      this.polygon.visible = true
      this.circle.visible = false
    },
    // 类型(多边形，圆形)
    rulesTypeUpdate() {
      //打点
      const position = this.data.location.split(",")
      this.position = [parseFloat(position[0]), parseFloat(position[1])]
      //矩形
      if (this.ruleList.ruleType == 1) {
        this.polygon.visible = true
        this.circle.visible = false
        if (this.ruleList.ruleParam) {
          // 图形
          const rulePolygonArry = this.ruleList.ruleParam.split(';')
          const path = []
          rulePolygonArry.forEach(item => {
            const pathArry = item.split(',')
            path.push([parseFloat(pathArry[0]), parseFloat(pathArry[1])])
          })
          this.polygon.path = path
          // 矩形第一个点
          const firstPath = rulePolygonArry[0].split(',')
          // this.center = [parseFloat(position[0]), parseFloat(position[1])]
          const lat1 = parseFloat(position[1])
          const lng1 = parseFloat(position[0])
          const lat2 = parseFloat(firstPath[1])
          const lng2 = parseFloat(firstPath[0])
          let minLat = 90
          let maxLat = -90
          let minLng = 180
          let maxLng = -180
          minLat = Math.min(lat1, lat2)
          maxLat = Math.max(lat1, lat2)
          minLng = Math.min(lng1, lng2)
          maxLng = Math.max(lng1, lng2)
          this.bounds = [[minLng, minLat], [maxLng, maxLat]]

          // if(5 <= dis){
          //   this.zoom = 11
          // }else if((3 <= dis) && (dis < 5)){
          //   this.zoom = 13
          // }else if((1 < dis) && (dis < 3)){
          //   this.zoom = 14
          // }else{
          //   this.zoom = 15
          // }
          // const cLng = (parseFloat(position[0])+parseFloat(firstPath[0]))/2
          // const cLat = (parseFloat(position[1])+parseFloat(firstPath[1]))/2
          // this.center = [cLng, cLat]
        }
      } else if (this.ruleList.ruleType == 2) {
        //圆形
        this.polygon.visible = false
        this.circle.visible = true
        if (this.ruleList.ruleParam) {
          const ruleArry = this.ruleList.ruleParam.split(';')
          const centerArry = ruleArry[0].split(',')
          this.circle.radius = parseFloat(ruleArry[1])
          this.circle.center = [parseFloat(centerArry[0]), parseFloat(centerArry[1])]
          // this.center = [parseFloat(position[0]), parseFloat(position[1])]
          const lat1 = parseFloat(position[1])
          const lng1 = parseFloat(position[0])
          const lat2 = parseFloat(centerArry[1])
          const lng2 = parseFloat(centerArry[0])
          let minLat = 90
          let maxLat = -90
          let minLng = 180
          let maxLng = -180
          minLat = Math.min(lat1, lat2)
          maxLat = Math.max(lat1, lat2)
          minLng = Math.min(lng1, lng2)
          maxLng = Math.max(lng1, lng2)
          this.bounds = [[minLng, minLat], [maxLng, maxLat]]
          // const dis = this.getDistance(lat1,  lng1,  lat2,  lng2)
          // if(5 <= dis){
          //   this.zoom = 11
          // }else if((3 <= dis) && (dis < 5)){
          //   this.zoom = 13
          // }else if((1 < dis) && (dis < 3)){
          //   this.zoom = 14
          // }else{
          //   this.zoom = 15
          // }
          // console.log((this.getDistance(lat1,  lng1,  lat2,  lng2)) +"&&"+this.zoom)
          // const cLng = (parseFloat(position[0])+parseFloat(centerArry[0]))/2
          // const cLat = (parseFloat(position[1])+parseFloat(centerArry[1]))/2
          // this.center = [cLng, cLat]

        }
      }
    },
    //计算两经纬度间的距离
    getDistance(lat1,  lng1,  lat2,  lng2){
      var radLat1 = lat1*Math.PI / 180.0
      var radLat2 = lat2*Math.PI / 180.0
      var a = radLat1 - radLat2
      var b = lng1*Math.PI / 180.0 - lng2*Math.PI / 180.0
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a/2),2) +
      Math.cos(radLat1)*Math.cos(radLat2)*Math.pow(Math.sin(b/2),2)))
      s = s *6378.137 // EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000
      return s
    }
  }
}
</script>

<style lang="scss">
*{
  font-style: normal;
}
.amap{
  height: 48vh;
  width: 100%;
  margin-bottom: 10px;
  position: relative;
}
.wl-flex-p{
  display: flex;
  span{
    flex: 1;
  }
}
.car-border{
  border: 1px dashed #ddd;
  flex: 1;
  padding:5px;
  .permanent{
    margin: 5px;
  }
}
.red{
  color: #ff0000;
}
.blue{
  color: #409EFF;
}
.loading-map .gm-svpc{
  display:none;
}
</style>
